import { render } from "./anteriores_baremos.vue?vue&type=template&id=79d7c056&scoped=true"
import script from "./anteriores_baremos.vue?vue&type=script&lang=js"
export * from "./anteriores_baremos.vue?vue&type=script&lang=js"

import "./anteriores_baremos.vue?vue&type=style&index=0&id=79d7c056&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79d7c056"]])

export default __exports__